// 组件入口

// 组件
import Icon from './icon';
import Input from './input';
import InputNumber from './input-number';
import InputTextarea from './input-textarea';
import InputGroup from './input-group';
import Loading from './loading';
import Button from './button';
import Checkbox from './checkbox';
import Radio from './radio';
import RadioGroup from './radio-group';
import Modal from './modal';
import Form from './form';
import Select from './select';
import Tabs from './tabs';
import Poptip from './poptip';
import Table from './table';
import Pagination from './pagination';
import Steps from './steps';
import Menu from './menu';
import Upload from './upload';
import Grid from './grid';
import Tree from './tree';
// import DatePicker from './date-picker';
import Timeline from './timeline';
import Breadcrumb from './breadcrumb';
import ConfirmPoptip from './confirm-poptip';
import Rate from './rate';
import Badge from './badge';
import Slider from './slider';
import Switch from './switch';
import Alert from './alert';
import Progress from './progress';
import ButtonGroup from './button-group';
import Transfer from './transfer';
import Popup from './popup';
import Tooltip from './tooltip';
import CheckboxGroup from './checkbox-group';
import Tag from './tag';
import Dropdown from './dropdown';

/*
 * 特殊组件
 * import pageLoading from './page-loading';
 * import confirm from './confirm';
 * import toast from './toast';
 */
import modalBox from './modal-box';
// IE处理
import './scripts/utils/ie';

// 栅格
const { Row, Col } = Grid;
// 表格项
const { FormItem } = Form;
// 选择器
const { SelectOption } = Select;
// 标签页
const { TabsPane } = Tabs;
// 步骤条
const { Step } = Steps;
// 菜单
const { Item: MenuItem, Sub: Submenu } = Menu;
// 时间轴
const { TimelineItem } = Timeline;
// 面包屑
const { BreadcrumbItem } = Breadcrumb;
// 下拉框
const { DropdownMenu, DropdownItem } = Dropdown;

const components = {
  Icon,
  Input,
  InputNumber,
  InputTextarea,
  InputGroup,
  Loading,
  Button,
  Row,
  Col,
  Checkbox,
  Radio,
  Modal,
  Form,
  FormItem,
  Select,
  SelectOption,
  Tabs,
  TabsPane,
  Poptip,
  Table,
  Pagination,
  Steps,
  Step,
  Menu,
  MenuItem,
  Submenu,
  Upload,
  Tree,
  Timeline,
  TimelineItem,
  Breadcrumb,
  BreadcrumbItem,
  ConfirmPoptip,
  Rate,
  Badge,
  Slider,
  Switch,
  Alert,
  Progress,
  ButtonGroup,
  Transfer,
  Popup,
  Tooltip,
  RadioGroup,
  CheckboxGroup,
  Tag,
  Dropdown,
  DropdownMenu,
  DropdownItem
};

const $modalBox = modalBox;

function install(Vue) {
  Object.keys(components).forEach(key => {
    Vue.component('hive' + key, components[key]);
  });

  Object.assign(Vue.prototype, {
    $modalBox
  });
}

// install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  ...components
};

export {
  $modalBox,
  Icon,
  Input,
  InputNumber,
  InputTextarea,
  InputGroup,
  Loading,
  Button,
  Row,
  Col,
  Checkbox,
  Radio,
  Modal,
  Form,
  FormItem,
  Select,
  SelectOption,
  Tabs,
  TabsPane,
  Poptip,
  Table,
  Pagination,
  Steps,
  Step,
  Menu,
  MenuItem,
  Submenu,
  Upload,
  Tree,
  Timeline,
  TimelineItem,
  Breadcrumb,
  BreadcrumbItem,
  ConfirmPoptip,
  Rate,
  Badge,
  Slider,
  Switch,
  Alert,
  Progress,
  ButtonGroup,
  Transfer,
  Popup,
  Tooltip,
  RadioGroup,
  CheckboxGroup,
  Tag,
  Dropdown,
  DropdownMenu,
  DropdownItem
};
